import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
// material
import { Card, Box, Grid, Typography, Divider, Stack, Skeleton } from '@mui/material';

import { capitalizeFirstLetter } from '../../../utils/Utilities';

// ----------------------------------------------------------------------

let TOTAL = 0;

if (process.env.REACT_APP_ENVIRONMENT === 'development') TOTAL = 800;

SoundBoxDevicesStats.propTypes = {
  admindashboardData: PropTypes.object,
  deviceDashboardData: PropTypes.object
};

export default function SoundBoxDevicesStats({ admindashboardData, deviceDashboardData }) {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const handleExpandChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Card
      sx={{
        background: '#FFFFFF',
        boxShadow: '10px 10px 19px 1px #EAEAFF',
        borderRadius: '20px',
        display: 'flex',
        alignItems: 'center',
        padding: '5px',
        height: '100%',
        width: '100%'
      }}
    >
      <Box
        sx={{
          width: '100%',
          borderRadius: '14px',
          p: { xs: 2.5, md: 4 },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 3
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            flex: 1,
            minWidth: 0
          }}
        >
          <Box sx={{ minWidth: 0, textAlign: 'left' }}>
            {admindashboardData?.totalMerchants !== undefined &&
            admindashboardData?.totalMerchants !== null ? (
              <Typography
                sx={{
                  fontWeight: 800,
                  color: '#171D40',
                  fontSize: { xs: '28px', md: '35px' },
                  lineHeight: 1,
                  fontFamily: 'Montserrat'
                }}
              >
                {admindashboardData?.totalMerchants}
              </Typography>
            ) : (
              <Skeleton variant="text" sx={{ height: 60, width: 140 }} />
            )}

            {admindashboardData?.totalMerchants !== undefined &&
            admindashboardData?.totalMerchants !== null ? (
              <Typography
                sx={{
                  fontWeight: 600,
                  color: '#171D40',
                  fontSize: { xs: '12px', md: '14px' },
                  mt: 0.5,
                  fontFamily: 'Montserrat',
                  textWrap: 'nowrap'
                }}
              >
                Total Merchants
              </Typography>
            ) : null}
          </Box>

          {/* Small stats column to the right of big number */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {admindashboardData?.totalMerchants !== undefined &&
            admindashboardData?.totalMerchants !== null ? (
              <>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      color: '#0DA626',
                      fontSize: '13px',
                      lineHeight: '16px',
                      textWrap: 'nowrap'
                    }}
                  >
                    Assigned :
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      color: '#171D40',
                      opacity: 0.8,
                      fontSize: '14px',
                      fontFamily: 'Montserrat'
                    }}
                  >
                    {admindashboardData?.totalMerchants - admindashboardData?.unAssignedMerchants}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      color: '#0DA626',
                      fontSize: '13px',
                      lineHeight: '16px',
                      textWrap: 'nowrap'
                    }}
                  >
                    Unassigned :
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      color: '#171D40',
                      opacity: 0.8,
                      fontSize: '14px',
                      fontFamily: 'Montserrat'
                    }}
                  >
                    {admindashboardData?.unAssignedMerchants}
                  </Typography>
                </Box>
              </>
            ) : (
              <>
                <Skeleton variant="text" sx={{ height: 24, width: 120 }} />
                <Skeleton variant="text" sx={{ height: 24, width: 120 }} />
              </>
            )}
          </Box>
        </Box>

        <Box sx={{ width: '1px', height: 64, bgcolor: 'rgba(0,0,0,0.08)', mx: 2 }} />

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            flex: 1,
            justifyContent: 'flex-start',
            minWidth: 0
          }}
        >
          {/* Big number + label */}
          <Box sx={{ minWidth: 0, textAlign: 'left' }}>
            {deviceDashboardData?.totalDevices !== undefined &&
            deviceDashboardData?.totalDevices !== null ? (
              <Typography
                sx={{
                  fontWeight: 800,
                  color: '#171D40',
                  fontSize: { xs: '28px', md: '35px' },
                  lineHeight: 1,
                  fontFamily: 'Montserrat'
                }}
              >
                {deviceDashboardData?.totalDevices}
              </Typography>
            ) : (
              <Skeleton variant="text" sx={{ height: 60, width: 80 }} />
            )}

            {deviceDashboardData?.totalDevices !== undefined &&
            deviceDashboardData?.totalDevices !== null ? (
              <Typography
                sx={{
                  fontWeight: 600,
                  color: '#171D40',
                  fontSize: { xs: '12px', md: '14px' },
                  mt: 0.5,
                  fontFamily: 'Montserrat',
                  textWrap: 'nowrap'
                }}
              >
                Total Devices
              </Typography>
            ) : null}
          </Box>

          {/* Device small stats column */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {deviceDashboardData?.totalDevices !== undefined &&
            deviceDashboardData?.totalDevices !== null ? (
              <>
                {deviceDashboardData?.totalDevicesByStatus?.map((row) => (
                  <Box key={row?.status} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: '#0DA626',
                        fontSize: '13px',
                        lineHeight: '16px'
                      }}
                    >
                      {capitalizeFirstLetter(row?.status)} :
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: '#171D40',
                        opacity: 0.8,
                        fontSize: '14px',
                        fontFamily: 'Montserrat'
                      }}
                    >
                      {row?.count}
                    </Typography>
                  </Box>
                ))}
              </>
            ) : (
              <>
                <Skeleton variant="text" sx={{ height: 24, width: 120 }} />
                <Skeleton variant="text" sx={{ height: 24, width: 120 }} />
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Card>
  );
}
